import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  SharedModule,
  FormInputComponent,
  RelationCustomFieldConfig,
  ModalService,
  DataService,
} from "@bb-vendure/admin-ui/core";
import { SelectCustomerGroupDialogComponent } from "../select-customer-group-dialog/select-customer-group-dialog.component";
import { Tag } from "@vendure/core";
import { GetCustomersDocument } from "../../generated-gql/graphql";
import { SelectCustomerFilterDialogComponent } from "../select-customer-filter-dialog/select-customer-filter-dialog.component";

type InputListItem = {
  id: number;
  // componentRef?: ComponentRef<FormInputComponent>;
  // control: UntypedFormControl;
};

@Component({
  imports: [SharedModule],
  standalone: true,
  templateUrl: "./customer-list-form-input.component.html",
  styleUrl: "./customer-list-form-input.component.scss",
})
export class CustomerListFormComponent
  implements OnInit, FormInputComponent<RelationCustomFieldConfig>
{
  isListInput?: boolean | undefined = true;
  readonly: boolean;
  formControl: FormControl<any>;
  config: RelationCustomFieldConfig;
  listItems: any[] = [];

  constructor(
    private modalService: ModalService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const customerIds: string[] = this.formControl.value;

    if (customerIds && customerIds.length > 0) {
      this.dataService
        .query(GetCustomersDocument, {
          options: {
            filter: {
              id: {
                in: customerIds,
              },
            },
          },
        })
        .single$.subscribe((res) => {
          this.listItems = res.customers.items;
          this.cdr.markForCheck();
        });
    }
  }

  trackById(index: number, item: { id: number }) {
    return item.id;
  }

  moveListItem(event: CdkDragDrop<InputListItem>) {
    if (this.listItems) {
      moveItemInArray(this.listItems, event.previousIndex, event.currentIndex);
    }
  }

  removeListItem(item: InputListItem) {
    if (this.listItems) {
      this.listItems = this.listItems.filter((i) => i !== item);
      this.formControl.patchValue(this.listItems.filter((i) => i !== item));

      this.formControl.markAsDirty();
    }
  }

  addListItem() {
    this.modalService
      .fromComponent(SelectCustomerFilterDialogComponent, {
        size: "xl",
      })
      .pipe()
      .subscribe((res) => {
        if (res?.selectedCustomers) {
          this.addCustomersToList(res.selectedCustomers);
        }
      });
  }

  // addGroupToList(groupId: string) {
  //   this.dataService.customer
  //     .getCustomerGroupWithCustomers(groupId, {})
  //     .single$.subscribe((res) => {
  //       if (res.customerGroup) {
  //         const newCustomers = res.customerGroup.customers;

  //         if (newCustomers.items.length > 0) {
  //           for (const newCustomer of newCustomers.items) {
  //             if (!this.listItems.find((i) => i.id === newCustomer.id)) {
  //               this.listItems.push(newCustomer);
  //             }
  //           }

  //           this.formControl.patchValue(this.listItems.map((i) => i.id));
  //           this.cdr.markForCheck();
  //           console.log(this.listItems);
  //         }
  //       }
  //     });
  // }

  addCustomersToList(customers: any[]) {
    if (customers.length <= 0) {
      return;
    }

    const list = [...this.listItems];

    for (const customer of customers) {
      if (!list.find((i) => i.id === customer.id)) {
        list.push(customer);
      }
    }

    this.listItems = list;

    this.formControl.patchValue(list.map((i) => i.id));

    this.cdr.markForCheck();
  }

  addCustomerToList(customer: any) {
    if (!this.listItems.find((i) => i.id === customer.id)) {
      this.listItems.push(customer);
      this.formControl.patchValue(this.listItems.map((i) => i.id));
      this.cdr.markForCheck();
    }
  }
}
